import { useState } from 'react'
import { useRouter } from 'next/router'
import { useWishlist } from './use-wishlist'
import {
    MutationCopyProductsBetweenWishlistsArgs,
    CopyProductsBetweenWishlistsOutput
} from '@pylot-data/pylotschema'
import { graphqlFetch, GraphqlFetchOutput } from '@pylot-data/graphqlFetch'
import { COPY_PRODUCTS_BETWEEN_WISHLISTS } from '../graphql/copyProductsBetweenWishlists'

export interface OutputInterface {
    copyProductsBetweenWishlists: CopyProductsBetweenWishlistsOutput
}

export interface UseCopyProductsBetweenWishlistInterface {
    isLoading: boolean
    copyProductsBetweenWishlists: (
        formInput: MutationCopyProductsBetweenWishlistsArgs
    ) => Promise<GraphqlFetchOutput<OutputInterface>>
}

export const useCopyProductsBetweenWishlists =
    (): UseCopyProductsBetweenWishlistInterface => {
        const { locale } = useRouter()
        const { mutate } = useWishlist()
        const [isLoading, setIsLoading] = useState(false)

        const copyProductsBetweenWishlists = async (
            formInput: MutationCopyProductsBetweenWishlistsArgs
        ) => {
            setIsLoading(true)

            const response = await graphqlFetch<
                MutationCopyProductsBetweenWishlistsArgs,
                OutputInterface
            >({
                query: COPY_PRODUCTS_BETWEEN_WISHLISTS,
                variables: formInput,
                locale
            })

            await mutate()
            setIsLoading(false)

            return response
        }

        return {
            isLoading,
            copyProductsBetweenWishlists
        }
    }
